
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <template v-if="move_kind == 'dept'">
        <move-dept
          :department="department"
          @close="$emit('close')"
          @changeMoveKind="handleChangeMoveKind"
          @updated="$emit('updated')"
        ></move-dept>
      </template>

      <template v-if="move_kind == 'associations'">
        <move-associations
          :department="department"
          @back="move_kind = 'dept'"
          @updated="$emit('updated')"
        ></move-associations>
      </template>
    </v-dialog>

    <dialog-loading v-if="loading" :loadingText="loading_text"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: "MoveDialog",
  components: {
    selectDepartmentDialog: () => import('../shared/SelectDepartmentDialog.vue'),
    selectDepartment: () => import('../shared/selectDepartment.vue'),
    moveDept: () => import('./dept/MoveDept.vue'),
    moveAssociations: () => import('./associations/MoveAssociations.vue')
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    department: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [
    validations
  ],
  data() {
    return {
      loading: false,
      loading_text: null,
      associations: null,
      associations_map: {
        "forms": {
          text: "Formulários",
          icon: ''
        },
        "flows": {
          text: "Fluxos",
          icon: ''
        },
        "action_plans": {
          text: "Planos de ação",
          icon: ''
        },
        "employees": {
          text: "Colaboradores",
          icon: ''
        },
        "children": {
          text: "Departamentos filhos",
          icon: ''
        }
      },
      move_actions: [
        {
          text: "Mover tudo",
          value: "all"
        },
        {
          text: "Selecionar individualmente",
          value: "individual"
        }
      ],
      submiting_move: false,
      move_kind: "dept", // "dept" || "associations"
      local_dept: null
    }
  },
  mounted () {
    this.getAssociations();
  },
  methods: {
    handleChangeMoveKind(kind) {
      this.move_kind = kind;
    },
    resetAssociations() {
      for (let association in this.associations) {
        this.associations[association].move = false;
        this.associations[association].type = null;
        this.associations[association].items = [];
        this.associations[association].dept_id = null
      }
    },
    setDeptToMove(dept) {
      this.local_dept = {...this.department};

      this.local_dept.ancestry = `${dept.ancestry}/${dept.id}`;
    },
    setChildrenDept(dept) {
      this.associations["children"].dept_id = dept.id;
    },
    updateChildrenList(children_list) {
      this.associations["children"].items = children_list.map((children) => children.id);
    },
    setEmployeeDept(dept) {
      this.associations["employees"].dept_id = dept.id;
    },
    updateEmployeeList(employee_list) {
      this.associations["employees"].items = employee_list.map((employee) => employee.id);
    },
    setFormDept(dept) {
      this.associations["forms"].dept_id = dept.id;
    },
    updateFormList(form_list) {
      this.associations["forms"].items = form_list.map((form) => form.id);
    },
    setFlowDept(dept) {
      this.associations["flows"].dept_id = dept.id;
    },
    updateFlowList(flow_list) {
      this.associations["flows"].items = flow_list.map((flow) => flow.id);
    },
    submitMove() {
      this.submiting_move = true;
      if (this.$refs.moveForm.validate() && this.can_move_everything) {
        this.loading = true;
        this.loading_text = "Movendo";
  
        let dept = {};
        if (this.move_kind == "dept") {
          dept = {
            ...this.local_dept
          }
        } else if (this.move_kind == "associations") {
          dept = {
            ...this.department,
            associations: {...this.associations},
            solution_id: this.solution_id
          }
        }

        let ACTION = this.move_kind == "dept" ? "updateDepartment" : "moveAssocitions"
  
        this[ACTION](dept).then(() => {
          this.loading = false;
          this.loading_text = null;
          this.$emit("updated");
        })
      }
    },
    async getAssociations() {
      this.loading = true;
      this.loading_text = "Carregando";

      this.departmentAssociations({department_id: this.department.id, solution_id: this.solution_id}).then((associations) => {
        // this.associations = [...associations];
        this.associations = associations.reduce((a, v) => ({ 
          ...a,
          [v]: {
            name: v,
            move: false, 
            type: null, // "all" || "individual",
            items: [],
            dept_id: null
          }
        }), {});
        this.loading = false;
        this.loading_text = null;
      });
    },
    ...mapActions({
      departmentAssociations: "Department/departmentAssociations",
      moveAssociations: "Department/moveAssociations",
      updateDepartment: "Department/updateDepartment"
    })
  },
  computed: {
    has_associations() {
      if (this.associations) {
        return Object.keys(this.associations).length === 0 ? false : true;
      }

      return false;
    },
    can_move_everything() {
      let can_move_forms = this.can_move_forms.can_move;
      let can_move_flows = this.can_move_flows.can_move;
      let can_move_employees = this.can_move_employees.can_move;
      let can_move_children = this.can_move_children.can_move;

      return can_move_forms && can_move_flows && can_move_employees && can_move_children;
    },
    can_move_flows() {
      let can_move = {
        can_move: true,
        text: null
      };
      let flows = {...this.associations["flows"]};

      if (flows.move) {
        if (flows.type == "individual") {
          if (!flows.items.length) {
            can_move.can_move = false;
            can_move.text = "Por favor selecione os fluxos a serem movidos"
          }
        }
      }

      return can_move;
    },
    can_move_employees() {
      let can_move = {
        can_move: true,
        text: null
      };
      let employees = {...this.associations["employees"]};

      if (employees.move) {
        if (employees.type == "individual") {
          if (!employees.items.length) {
            can_move.can_move = false;
            can_move.text = "Por favor selecione os colaboradores a serem movidos";
          }
        }
      }

      return can_move;
    },
    can_move_children() {
      let can_move = {
        can_move: true,
        text: null
      };
      let children = {...this.associations["children"]};

      if (children.move) {
        if (children.type == "individual") {
          if (!children.items.length) {
            can_move.can_move = false;
            can_move.text = "Por favor selecione os departamentos filhos a serem movidos";
          }
        }
      }

      return can_move;
    },
    can_move_forms() {
      let can_move = {
        can_move: true,
        text: null
      };
      let forms = {...this.associations["forms"]};

      if (forms.move) {
        if (forms.type == "individual") {
          if (!forms.items.length) {
            can_move.can_move = false;
            can_move.text = "Por favor selecione os formulários a serem movidos";
          }
        }
      }

      return can_move;
    },
    ...mapState({
      one_department: state => state.Department.one_department,
      solution_id: state=>state.Solution.solutionID,
    })
  },
  watch: {
    move_kind(nv, ov) {
      if (nv) {
        this.resetAssociations();
      }
    }
  },
}
</script>

<style scoped>

</style>